import { rootStore } from 'stores/root/RootStore';
import BaseStore from 'stores/BaseStore';

export function registerStore<T extends BaseStore>(
  storeName: string,
  store: T,
): void {
  if (storeName in rootStore.stores) {
    // // throw new Error('store already registered');
    // console.log(`store replaced ${storeName}`);
  } else {
    //
  }
  rootStore.stores[storeName] = store;
  console.log(`${storeName} registered`);
}

export function registerStoreIfNotExists<T extends BaseStore>(
  storeName: string,
  store: T,
): void {
  if (!(storeName in rootStore.stores)) {
    rootStore.stores[storeName] = store;
  }
}
